import React from "react";
import { styled } from "@mui/system";
import MUIBreadcrumbs, { BreadcrumbsProps } from "@mui/material/Breadcrumbs";

export const Breadcrumbs = styled(
  (props: BreadcrumbsProps) => <MUIBreadcrumbs {...props} />,
  {
    name: "Breadcrumbs",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  "&.MuiBreadcrumbs-root .MuiBreadcrumbs-separator": {
    color: theme.palette.primary.iconDefault,
    justifyContent: "center",
    alignItems: "center",
    width: 20,
    height: 20,
  },
  "&.MuiBreadcrumbs-root .MuiBreadcrumbs-separator .MuiSvgIcon-root ": {
    height: 10,
  },
  "&.MuiBreadcrumbs-root .MuiBreadcrumbs-li:last-child > .MuiTypography-body1 ":
    {
      textDecoration: "none",
      fontFamily: "Roboto",
      fontWeight: 500,
      fontSize: 14,
      color: theme.palette.primary.textTitleColor,
    },
  "&.MuiBreadcrumbs-root .MuiBreadcrumbs-ol li > .MuiButtonBase-root ": {
    background: theme.palette.primary.inputBackgroundDefault,
    color: theme.palette.primary.textSubduedColor,
  },
}));
